import React from 'react';
import MovieRow from '../../components/MovieRow/MovieRow';
import FeaturedItem from '../../components/FeaturedItem/FeaturedItem';
import {Grid, Skeleton, Fade} from '@mui/material';


const Home = ({movieList, featuredItem}) => {

    return(
        <>
        {featuredItem?
            <FeaturedItem item={featuredItem} currentView={'home'}/>
        :
        <div style={{height:"85vh",width:"100%", display:"grid", flexWrap:"wrap", alignContent:"center",}}>
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"8px", marginLeft:"3rem" }} variant="rect" width={'60%'} height={'3.75rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"3px", marginLeft:"3rem", marginTop:"4%" }} variant="rect" width={'35%'} height={'1.2rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"8px", marginLeft:"3rem", marginTop:"1rem" }} variant="rect" width={'45%'} height={'6rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"3px", marginLeft:"3rem", marginTop:"1rem" }} variant="rect" width={'25%'} height={'1.2rem'} />
        <Skeleton animation="wave" sx={{ bgcolor: '#ffffff0f', borderRadius:"3px", marginLeft:"3rem", marginTop:"3%" }} variant="rect" width={'8rem'} height={'2.75rem'} />
      </div>
        }
        <div style={{marginTop:"-5rem", paddingBottom:"5rem"}}>
          {movieList.map((item,key)=>(
             <MovieRow key={key} category={item}/>

          ))} 
          </div>
        </>
    );
}
export default Home
